<div class="flex flex-col w-full h-full bg-white rounded-2xl overflow-hidden">
    <!-- Header -->
    <div class="flex justify-between items-center px-6 py-5 border-b border-gray-200">
        <h2 class="text-[20px] font-semibold font-inter text-gray-900 m-0">Alterar email</h2>
        <button mat-icon-button (click)="closeModal()" class="w-9 h-9 text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200">
            <mat-icon class="icon-size-6" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex-1 p-6 pb-[86px] overflow-y-auto">
        <form [formGroup]="changeEmailForm">
            <!-- Email -->
            <mat-form-field class="w-full">
                <mat-label>Email</mat-label>
                <input
                    matInput
                    type="email"
                    formControlName="email"
                    placeholder="Digite seu novo email">
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'mat_outline:email'"></mat-icon>
                <mat-error *ngIf="changeEmailForm.get('email')?.hasError('email')">
                    Digite um email válido
                </mat-error>
            </mat-form-field>

            <!-- Repetir Email -->
            <mat-form-field class="w-full mt-4">
                <mat-label>Repetir email</mat-label>
                <input
                    matInput
                    type="email"
                    formControlName="confirmEmail"
                    placeholder="Digite novamente seu novo email">
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'mat_outline:email'"></mat-icon>
                <mat-error *ngIf="changeEmailForm.hasError('emailMismatch') && changeEmailForm.get('confirmEmail')?.touched">
                    Os emails não coincidem
                </mat-error>
            </mat-form-field>
        </form>
    </div>

    <!-- Footer -->
    <div class="absolute flex bottom-0 left-0 right-0 p-6 w-full flex-row-reverse bg-white border-t border-gray-200">
        <div class="relative w-[118px] h-[38px]">
            <button
                [disabled]="changeEmailForm.invalid || loading"
                (click)="saveEmail()"
                class="w-full h-full flex px-6 py-2 rounded-3xl bg-[#0061ff] hover:bg-[#2f75e7] relative cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
                <span class="mr-2 font-remote font-[400] text-[15px] text-white" *ngIf="!loading">Salvar</span>
                <mat-icon class="icon-size-5 text-white relative" [svgIcon]="'mat_solid:save'" *ngIf="!loading"></mat-icon>
                <mat-progress-spinner *ngIf="loading" [diameter]="18" [mode]="'indeterminate'" class="m-auto spinner-white"></mat-progress-spinner>
            </button>
        </div>
    </div>
</div>
